// extracted by mini-css-extract-plugin
export default {"content":"styles_content__zI21s","body":"styles_body__tWZ8C"};